/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';

function DropdownPersist({ show, ...rest }) {
  const [open, setOpen] = useState(show);
  const onToggle = (isOpen) => {
    setOpen(isOpen);
  };
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Dropdown show={open} onToggle={onToggle} {...rest} />;
}

DropdownPersist.propTypes = {
  /**
   * The visbility boolean
   */
  show: PropTypes.bool,
  /**
   * The function called when toggling the dropdown
   */
  handleToggle: PropTypes.func,
};

export default DropdownPersist;
